export default {
  'questionnaire:check-order': `Bestelling controleren`,
  'questionnaire:go-to-overview': `Naar besteloverzicht`,
  'questionnaire:next': `Verder`,

  'questionnaire:header:in-process-message': `Je bestelling wordt verwerkt.`,
  'questionnaire:header:in-processed-message': `Je bestelling is volledig verwerkt.`,
  'questionnaire:header:error-message': `Er is een probleem opgetreden met je bestelling!`,

  'questionnaire:introduction:opening-message': `We willen jou en je viervoeter graag wat beter leren kennen.
  Omdat je familie bent! Daarom zouden we het geweldig vinden
  als je even de tijd neemt om twee vragen te beantwoorden.
  Bedankt en veel plezier met je bestelling, je Pets Deli
  Team`,
  'questionnaire:introduction:closing-message': `Bedankt voor je feedback. We wensen jou en je
  viervoeter veel plezier met onze producten.`,
  'questionnaire:introduction:no': 'Nee, bedankt',
  'questionnaire:introduction:yes': 'Graag',

  'questionnaire:breed:loading': 'Laden',
  'questionnaire:breed:no-options-found': 'Geen opties gevonden',

  'questionnaire:input-placeholder': 'Hier invoeren',
};
